export default __webpack_public_path__ + "static/media/ground_selected.45ccd54d.png";